"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'MarketDetail',
  props: {
    marketData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    // 调试信息：打印数据结构
    console.log('MarketDetail - marketData:', this.marketData);
    console.log('MarketDetail - marketAreaList:', this.marketData.marketAreaList);
    if (this.marketData.marketAreaList && this.marketData.marketAreaList.length > 0) {
      console.log('MarketDetail - 第一个区域的marketStallList:', this.marketData.marketAreaList[0].marketStallList);
    }
  },
  methods: {
    // 获取集市属性名称
    getSiteTypeName: function getSiteTypeName(siteType) {
      var siteTypeMap = {
        1: '商圈',
        2: '社区',
        3: '公园',
        4: '场馆',
        5: '景区',
        6: '乐园',
        7: '展会'
      };
      return siteTypeMap[siteType] || '未知';
    },
    // 处理图片字符串数组
    getImageList: function getImageList(imageStr) {
      if (!imageStr) return [];
      if (typeof imageStr === 'string') {
        try {
          return JSON.parse(imageStr);
        } catch (error) {
          console.warn('图片数据解析失败:', error);
          return [];
        }
      }
      return Array.isArray(imageStr) ? imageStr : [];
    },
    // 处理设施列表
    getFacilitiesList: function getFacilitiesList(facilitiesStr) {
      if (!facilitiesStr) return [];
      if (typeof facilitiesStr === 'string') {
        return facilitiesStr.split(',').filter(function (facility) {
          return facility.trim();
        });
      }
      return Array.isArray(facilitiesStr) ? facilitiesStr : [];
    },
    // 获取区域列表（兼容多种数据结构）
    getAreaList: function getAreaList() {
      // 优先使用 marketAreaList
      if (this.marketData.marketAreaList && this.marketData.marketAreaList.length > 0) {
        return this.marketData.marketAreaList;
      }
      // 兼容旧的数据结构 marketAreaInfoRespList
      if (this.marketData.marketAreaInfoRespList && this.marketData.marketAreaInfoRespList.length > 0) {
        return this.marketData.marketAreaInfoRespList;
      }
      return [];
    },
    // 根据区域ID获取摊位列表（兼容多种数据结构）
    getStallsByAreaId: function getStallsByAreaId(areaId) {
      if (!areaId) return [];

      // 从区域列表中查找对应区域，获取其内部的marketStallList
      var areaList = this.getAreaList();
      var area = areaList.find(function (area) {
        return area.id === areaId;
      });
      if (area) {
        // 优先使用区域内部的 marketStallList
        if (area.marketStallList && area.marketStallList.length > 0) {
          return area.marketStallList;
        }
        // 兼容旧的数据结构 stallInfoRespList
        if (area.stallInfoRespList && area.stallInfoRespList.length > 0) {
          return area.stallInfoRespList;
        }
      }

      // 如果区域内部没有摊位列表，尝试从全局的marketStallList中筛选
      if (this.marketData.marketStallList && this.marketData.marketStallList.length > 0) {
        return this.marketData.marketStallList.filter(function (stall) {
          return stall.areaId === areaId;
        });
      }
      return [];
    }
  }
};